import { render, staticRenderFns } from "./FontCreateModal.vue?vue&type=template&id=24712456&scoped=true&"
import script from "./FontCreateModal.vue?vue&type=script&lang=js&"
export * from "./FontCreateModal.vue?vue&type=script&lang=js&"
import style0 from "./FontCreateModal.vue?vue&type=style&index=0&id=24712456&scoped=true&lang=scss&"
import style1 from "./FontCreateModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24712456",
  null
  
)

/* custom blocks */
import block0 from "./FontCreateModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardTitle,VContainer,VDialog,VFileInput,VForm,VTextField})
